import React from 'react';
import './Statistics.css';

import TimeIcon from '../../icons/time_icon.png';
import JumpIcon from '../../icons/jump_icon.svg';
import TurnIcon from '../../icons/turn_icon.png';

function Statistics({ statistics }) {
  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`; // Ensures seconds are two digits
  };

  return (
    <div className="statistics-container">
      <div className="stat-item-container">
        <div className="stat-symbol"><img src={TimeIcon} alt="Time on Pointe" className="icon-small"/></div>
        <div className="stat-label">Time on pointe</div>
        <div className="stat-value">
          {formatTime(statistics.timeOnPointe)} {/* Format the time */}
          <span className="small-text"> mins</span> {/* Small text for "mins" */}
        </div>
      </div>
      
      <div className="stat-item-container">
        <div className="stat-symbol"><img src={JumpIcon} alt="Jumps" className="icon-small"/></div> {/* Replace with an icon or symbol of your choice */}
        <div className="stat-label">Jumps</div>
        <div className="stat-value">{statistics.jumps}</div>
      </div>
      
      <div className="stat-item-container">
        <div className="stat-symbol"><img src={TurnIcon} alt="Turns" className="icon-small"/></div> {/* Replace with an icon or symbol of your choice */}
        <div className="stat-label">Turns</div>
        <div className="stat-value">{statistics.turns}</div>
      </div>

      {/* Wrapper for horizontal alignment for overall status*/}
      <div className="alignment-row">
        <div 
          className={`stat-item-container alignment2 ${statistics.Lalignmentstat}`}
          style={{
            backgroundColor: 
              statistics.Lalignmentstat === 'good' ? '#00ff00' :
              statistics.Lalignmentstat === 'ok' ? '#ffff00' :
              statistics.Lalignmentstat === 'bad' ? '#ff0000' :
              '#93bbfc'
          }}
        >
          <h4>LF Alignment</h4>
          <div className="alignment2-status">
            {statistics.Lalignmentstat ? statistics.Lalignmentstat.toUpperCase() : 'N/A'}
          </div>
        </div>

        <div 
          className={`stat-item-container alignment2 ${statistics.Ralignmentstat}`}
          style={{
            backgroundColor: 
              statistics.Ralignmentstat === 'good' ? '#00ff00' :
              statistics.Ralignmentstat === 'ok' ? '#ffff00' :
              statistics.Ralignmentstat === 'bad' ? '#ff0000' :
              '#93bbfc'
          }}
        >
          <h4>RF Alignment</h4>
          <div className="alignment2-status">
            {statistics.Ralignmentstat ? statistics.Ralignmentstat.toUpperCase() : 'N/A'}
          </div>
        </div>
      </div>
      
      {/* Wrapper for horizontal alignment */}
      <div className="alignment-row">
        <div className="stat-item-container alignment">
          <h4>LF Alignment</h4>
          <div className="alignment-plot">
            <svg width="100%" height="150" viewBox="0 0 100 100">
              <line x1="0" y1="50" x2="100" y2="50" stroke="rgba(0,0,0,0.1)" />
              <line x1="50" y1="0" x2="50" y2="100" stroke="rgba(0,0,0,0.1)" />
              <circle
                cx={statistics.Lalignment?.x || 50}
                cy={statistics.Lalignment?.y || 50}
                r="8"
                fill={
                  statistics.Lalignmentstat === 'good' ? '#00ff00' :
                  statistics.Lalignmentstat === 'ok' ? '#ffff00' :
                  statistics.Lalignmentstat === 'bad' ? '#ff0000' :
                  '#cccccc'
                }
                stroke="rgba(0,0,0,0.2)"
                strokeWidth="1"
              />
            </svg>
          </div>
        </div>
        
        <div className="stat-item-container alignment">
          <h4>RF Alignment</h4>
          <div className="alignment-plot">
            <svg width="100%" height="150" viewBox="0 0 100 100">
              <line x1="0" y1="50" x2="100" y2="50" stroke="rgba(0,0,0,0.1)" />
              <line x1="50" y1="0" x2="50" y2="100" stroke="rgba(0,0,0,0.1)" />
              <circle
                cx={statistics.Ralignment?.x || 50}
                cy={statistics.Ralignment?.y || 50}
                r="8"
                fill={
                  statistics.Ralignmentstat === 'good' ? '#00ff00' :
                  statistics.Ralignmentstat === 'ok' ? '#ffff00' :
                  statistics.Ralignmentstat === 'bad' ? '#ff0000' :
                  '#cccccc'
                }
                stroke="rgba(0,0,0,0.2)"
                strokeWidth="1"
              />
            </svg>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Statistics;